import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetProductsQuery } from '@repair/catalog/hooks';

import { getAppRoute, RoutesPath } from '../../../core/routes';
import { useFetchSearchResult } from '../../../apis/search/search';
import { useSearchNavigation } from './SearchNavigationContext';
import { LoaderContext } from '../../../utils/loader/LoaderProvider';

export const CatalogProductSheetNavigator = () => {
  const navigate = useNavigate();
  const { pendingProductSheetId, setPendingProductSheetId } = useSearchNavigation();
  const { data: catalogProductHits } = useGetProductsQuery({
    productIds: pendingProductSheetId ? [pendingProductSheetId] : undefined,
  });
  const catalogProductHit = catalogProductHits?.[0];
  const { resetRequest } = useFetchSearchResult({ requestType: 'search' });
  const { hideLoader } = useContext(LoaderContext);

  useEffect(() => {
    if (!pendingProductSheetId || !catalogProductHit) return;

    const process = catalogProductHit.processes?.toSorted((a, b) => a.ranking - b.ranking)[0];
    const processId = process?.id;
    const groupNatureLevelTwoId = catalogProductHit.groupNatureLevelTwo?.id;
    const categoryId = process?.categories.find(cat => cat.active)?.id;

    setPendingProductSheetId(null);

    const url = new URL(getAppRoute(RoutesPath.productSheetPage, pendingProductSheetId), globalThis.location.origin);

    url.searchParams.set('processId', String(processId ?? ''));
    url.searchParams.set('groupNatureLevelTwoId', String(groupNatureLevelTwoId ?? ''));

    if (categoryId !== undefined) url.searchParams.set('categoryId', String(categoryId));

    navigate(url.pathname + url.search);
    hideLoader();
    resetRequest();
  }, [catalogProductHit, pendingProductSheetId]);

  return null;
};
